import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import GalleryPage from "@/pages/GalleryPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import PricingPage from "@/pages/PricingPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import AdminPage from "@/pages/AdminPage";
import ReferPage from "@/pages/ReferPage";
import LinksPage from "@/pages/LinksPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

// Layout wrapper to conditionally show navbar/footer
function Layout({ children }) {
  const location = useLocation();
  const isAdminPage = location.pathname === "/admin";
  const isReferPage = location.pathname === "/refer";
  const isLinksPage = location.pathname === "/links";
  
  return (
    <>
      {!isAdminPage && !isReferPage && !isLinksPage && <Navbar />}
      <main className="flex-grow">{children}</main>
      {!isAdminPage && !isReferPage && !isLinksPage && <Footer />}
      {!isAdminPage && !isReferPage && !isLinksPage && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/booking/success" element={<BookingSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/refer" element={<ReferPage />} />
            <Route path="/links" element={<LinksPage />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
